import { type FilterTab } from 'recruiter/components/FiltersDrawer'
import { useCandidateSqlSearch } from 'recruiter/hooks'
import { type CandidateFilterState } from 'shared/hooks/candidateSearchUrlState'

type TabBuilder = (
    filters: CandidateFilterState,
    updateFilters: (patch: Partial<CandidateFilterState>) => void
) => FilterTab[]

export function useCandidateFilterTabs(buildTabs: TabBuilder) {
    const { tableState, setTableState } = useCandidateSqlSearch()
    const filters = tableState.filters

    const updateFilters = (patch: Partial<CandidateFilterState>) => {
        setTableState({ filters: { ...filters, ...patch } })
    }

    return buildTabs(filters, updateFilters)
}
